module.exports = __webpack_public_path__ + "img/outboundorderselected.1b87b8b6.jpg";